export interface ILeaderboard {
  _id: string
  timeFrame: string
  rank: number
  totalPoints: number
  user: {
    fullName: string
    slug: string
    avatar?: string
    contactId: string
  }
  relativeTime?: string
  updatedAt: string
}

export enum TimeFrame {
  SEVEN_DAY = '7D',
  ALL_TIME = 'ALL_TIME',
  THIRTY_DAY = '30D',
}
